import { AddAlert } from "../../../components"
import { history, idRdm, numberAleatori, paramsApi } from "../../../helpers"
import api from "../../../helpers/api"
import apiV3 from '../../../helpers/apiV3';
import { loaded, loading, modalAlertaClean, modalAlertaInfo, modalClose, modalOpen, setInfoEmpresa, setInfoGrupo, setListarEmpresas, setListarGrupos, setListarProjetos, setProjeto, setProjetoMeusProjetos, verificaCreditoConta, setRecebePopupCriaEmpresa, setRecebePopupCriaEstabelecimento, setRecebePopupVerificaEstabelecimento, setRecebePopupCriaProduto } from "../../../layout/redux/layoutActions"
import { gerarLista, gerarListaEmpresas, gerarListaEstabelecimentos, gerarListaProdutos, paginateInit } from "./meusProjetos"



export const setListMeusProjetos = payload => ({
  type: 'LIST_MEUS_PROJETOS',
  payload
})

export const setListMeuProjeto = payload => ({
  type: 'SET_MEUS_PROJETOS',
  payload
})

export const putListMeuProjeto = payload => ({
  type: 'PUT_MEUS_PROJETOS',
  payload
})

export const setFormProjeto = payload => ({
  type: 'SET_FORM_MEUS_PROJETO',
  payload
})

export const setFormProjetoLista = payload => ({
  type: 'SET_FORM_MEUS_PROJETO_LIST',
  payload
})

export const cleanFormProjeto = payload => ({
  type: 'CLEAN_FORM_MEUS_PROJETO',
  payload
})

export const setErroProjeto = payload => ({
  type: 'SET_MEUS_PROJETO_ERRO',
  payload
})

export const setProjetosCarregados = (payload) => ({
  type: 'SET_PROJETOS_CARREGADOS',
  payload
});


export const projetoComentariosVistos = (projetoId, nlsPopup) => {
  return dispatch => {
    api.post(`/Projeto/RegistraVisualizouProjeto?projetoId=${projetoId}`)
      .catch(err => {
        console.error('Erro ao registrar visualização do projeto:', err);
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            show: true, // Garante que o modal será exibido
          })
        );
      });
  };
};

export const listarMeusProjetos = (e, nlsPopup) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState;
    
    try {
      // 1. Inicia o loading
      dispatch(loading());

      // 2. Faz a chamada API e ESPERA a resposta
      const response = await api.get(`/Projeto/ListaProjetos`);
      
      // 3. Processa os dados da resposta
      const infoHas = response.data?.informacoesProjetos || [];
      const projetosAtivos = infoHas
        .filter(p => p.situacao !== 'I')
        .map(p => ({
          ...p,
          id: p.idProjeto,
          nomeProjeto: p.descricao
        }));

      // 4. Encontra o projeto específico se houver ID
      let projetoSelecionado = projetosAtivos[0];
      if (e) {
        projetoSelecionado = projetosAtivos.find(p => String(p.idProjeto) === String(e));
      }

      
      // 5. Atualiza o estado em sequência com AWAIT
      await dispatch(setListMeusProjetos(response.data)); // Lista completa
      
      await dispatch(setListarProjetos(projetosAtivos)); // Projetos filtrados
      
      // 6. Só continua após atualizar o projeto principal
      
      /*
      if (projetoSelecionado) {
        await dispatch(setProjetoMeusProjetos(projetoSelecionado));
      }
      */
      // Só define o projeto ativo e dispara a cadeia de detalhes se:
      // 1. Nenhum ID específico foi passado (e)
      // 2. A flag `projetosCarregados` ainda é false (primeira execução)
      //Isso foi feito, porque após login, as apis de ListaEmpresas, ListaEstabelecimentos, ListaGrupoEstabelecimentos
      //era chamada 3 vezes. Entre as chamadas, o usuário poderia clicar no ícone de visualização e 
      //aí dava erro no combo de empresas
      if (!e && projetoSelecionado && !getState().meusProjetosState.projetosCarregados) {
          await dispatch(setProjetoMeusProjetos(projetoSelecionado));
          // Após carregar com sucesso pela primeira vez, define a flag como true
          await dispatch(setProjetosCarregados(true));
      }
      
      // 7. Retorna os projetos para uso posterior
      return projetosAtivos;

    } catch (error) {
      console.error('Erro ao listar projetos:', error);
      
      // Tratamento específico para erro 999 (sessão expirada)
      if (error.response?.data?.iderro === 999) {
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[29],
            show: true,
            btnAction: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
            btnClose: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
          })
        );
      } 
    } finally {
      // Garante que o loading é finalizado mesmo em caso de erro
      dispatch(loaded());
    }
  };
};




//DESCONTINUADO PORQUE PRECISA PASSAR nlsPopup para tratar erro 999, mas reparei que existem chamadas que não passam o nlsPopup como 
export const listarMeusProjetosOLD = (e, nlsPopup) => {
  return dispatch => {
    // dispatch(setListMeusProjetos(gerarLista()))
    api.get(`/Projeto/ListaProjetos`)
    .then(result => {
      
      const infoHas = result.data?.informacoesProjetos || []
      const projetos = infoHas?.filter(p=> p.situacao !== 'I')?.map(p=> ({...p, id: p.idProjeto, nomeProjeto: p.descricao}))
      let projeto = projetos[0]
      if (e) {
        projeto = projetos?.find(p=> String(p.idProjeto) === String(e))
      }

      console.log("ENTROU EM LISTAPROJETOS COM PROJETO:", projetos)
      dispatch(setListMeusProjetos(result.data))
      dispatch(setListarProjetos(projetos))
      //console.log("ABC PROJETO EM MEUSPROJETOSACTIONS LINHA 124", projeto)
      dispatch(setProjetoMeusProjetos(projeto))
    })
    .catch(err => {
        console.error(err, 'listarMeusProjetos');
        if (err.response.data.iderro === 999) {
          dispatch(
            modalAlertaInfo({
              ...nlsPopup[29],
              show: true,
              btnAction: () => {
                history.push('/login')
                dispatch(modalAlertaClean())
              },
              btnClose: () => {
                history.push('/login')
                dispatch(modalAlertaClean())
              },
            })
          )
        }
    });
  }
}


export const listarMeusProjetosEmpresas = (params, controlarLoading = true) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState;
    const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`);

    try {
      if (controlarLoading) {
        dispatch(loading());
      }

      const response = await api.get(`/Empresa/ListaEmpresas${paramsApi(params)}`);
      
      if (!response.data || typeof response.data === 'string') {
        throw new Error(response.data || 'Resposta da API inválida');
      }

      const infoHas = response.data.usuaempresasrios || response.data.informacoesEmpresa || [];
      const empresas = infoHas.map(r => ({
        ...r, 
        descricaoEmpresa: r.nomeEmpresa
      }));

      await dispatch(setFormProjetoLista({
        name: 'empresas',
        value: response.data.usuaempresasrios || response.data.informacoesEmpresa
      }));

      await dispatch(setFormProjetoLista({
        name: 'empresasPaginate',
        value: {
          ...paginateInit(),
          ...(response.data.paginacao || { totalElements: response.data.quantidadeEmpresas || 0 })
        }
      }));

      await dispatch(setListarEmpresas(empresas));
      await dispatch(setInfoEmpresa(empresas[0] || {}));

      return empresas;

    } catch (error) {
      console.error('Erro ao listar empresas:', error);
      
      if (error.response?.data?.iderro === 999) {
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[29],
            show: true,
            btnAction: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
            btnClose: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
          })
        );
      }

      dispatch([
        setListarEmpresas([]),
        setInfoEmpresa({})
      ]);

    } finally {
      if (controlarLoading) {
        dispatch(loaded());
      }
    }
  };
};



export const listarMeusProjetosEmpresasOLD33 = (params) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState;
    const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`);

    try {
      // 1. Inicia o estado de loading
      dispatch(loading());

      // 2. Faz a chamada API e ESPERA a resposta
      const response = await api.get(`/Empresa/ListaEmpresas${paramsApi(params)}`);
      
      // 3. Verifica se há dados válidos na resposta      
      if (!response.data || typeof response.data === 'string') {
        throw new Error(response.data || 'Resposta da API inválida');
      }
      

      // 4. Processa os dados da resposta
      const infoHas = response.data.usuaempresasrios || response.data.informacoesEmpresa || [];
      const empresas = infoHas.map(r => ({
        ...r, 
        descricaoEmpresa: r.nomeEmpresa
      }));

      // 5. Atualiza o estado em sequência
      await dispatch(setFormProjetoLista({
        name: 'empresas',
        value: response.data.usuaempresasrios || response.data.informacoesEmpresa
      }));

      await dispatch(setFormProjetoLista({
        name: 'empresasPaginate',
        value: {
          ...paginateInit(),
          ...(response.data.paginacao || { totalElements: response.data.quantidadeEmpresas || 0 })
        }
      }));

      await dispatch(setListarEmpresas(empresas));
      await dispatch(setInfoEmpresa(empresas[0] || {}));

      // 6. Retorna os dados para uso posterior
      return empresas;

    } catch (error) {
      console.error('Erro ao listar empresas:', error);
      
      // Tratamento específico para erro 999 (sessão expirada)
      if (error.response?.data?.iderro === 999) {
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[29],
            show: true,
            btnAction: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
            btnClose: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
          })
        );
      } 
      // Atualiza estado com valores vazios em caso de erro
      dispatch([
        setListarEmpresas([]),
        setInfoEmpresa({})
      ]);

      

    } finally {
      // 7. Garante que o loading é finalizado mesmo em caso de erro
      dispatch(loaded());
    }
  };
};

export const listarMeusProjetosEmpresasOLDX = e => {
  const params = paramsApi(e)
  return (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`)

    api.get(`/Empresa/ListaEmpresas${params}`)
    .then(result => {
      if (result.data && typeof result.data !== 'string') {
        const infoHas = (result.data?.usuaempresasrios?result.data.usuaempresasrios:result.data.informacoesEmpresa) || []
        let empresas = infoHas?.map(r=> ({...r, descricaoEmpresa: r.nomeEmpresa}))

        dispatch([
          setFormProjetoLista({name: 'empresas', value: result.data.usuaempresasrios?result.data.usuaempresasrios:result.data.informacoesEmpresa}),
          setFormProjetoLista({name: 'empresasPaginate', value: {...paginateInit(), ...result.data.paginacao?result.data.paginacao:{totalElements: result.data.quantidadeEmpresas}}}),

          setListarEmpresas(empresas),
          setInfoEmpresa(empresas[0])
        ])
      } else {
        dispatch([
          setListarEmpresas([]),
          setInfoEmpresa({})
        ])
        // dispatch(AddAlert('error', result.data))
      }
    })
    .catch(err => {
        console.error(err, 'listarMeusProjetos');
        if (err.response.data.iderro === 999) {
          dispatch(
            modalAlertaInfo({
              ...nlsPopup[29],
              show: true,
              btnAction: () => {
                history.push('/login')
                dispatch(modalAlertaClean())
              },
              btnClose: () => {
                history.push('/login')
                dispatch(modalAlertaClean())
              },
            })
          )
        }
        dispatch([
          setListarEmpresas([]),
          setInfoEmpresa({})
        ])
    });
  }
}



export const setListMeuProjetoTab = payload => ({
  type: 'SET_MEUS_PROJETOS_TAB',
  payload
})

export const putListMeuProjetoTab = payload => ({
  type: 'PUT_MEUS_PROJETOS_TAB',
  payload
})

export const removeListMeuProjetoTab = payload => ({
  type: 'REMOVE_MEUS_PROJETOS_TAB',
  payload
})

export const setMeusProjetosLoad = payload => ({
  type: 'SET_MEUS_PROJETO_LOAD',
  payload
})


// Ação para buscar sugestões de endereços
export const buscarSugestoesEnderecos = (query, sessionToken, idioma, empresa) => {

  const idiomaAjustado = idioma === 'esp' ? 'es' : idioma || 'en';

  // Ajusta o input baseado na empresa
  const input = empresa.trim() ? `${empresa} ${query}` : query;

  const params = paramsApi({
    input: input,          // Texto digitado
    sessionToken: sessionToken, // Token da sessão
    pais: '', //'BR',            // País: Brasil
    idioma: idiomaAjustado, // 'pt-br',       // Idioma: Português
  });

  return (dispatch) => {
    apiV3.get(`/Endereco/enderecos${params}`) // Passa os parâmetros tratados
      .then((response) => {
        if (response.data?.predictions) {
          // Envia as sugestões para o reducer
          dispatch({
            type: 'SET_ENDERECOS_SUGESTOES',
            payload: response.data.predictions,
          });
        }
      })
      .catch((error) => {
        console.error('Erro ao buscar sugestões de endereços:', error);
      });
  };
};

// Ação para limpar as sugestões de endereços
export const clearSugestoesEnderecos = () => {
  return (dispatch) => {
    dispatch({
      type: 'CLEAR_ENDERECOS_SUGESTOES',
    });
  };
};

export const buscarEnderecoDetalhado = (placeId) => {
  const params = paramsApi({
    placeId: placeId, // ID do lugar selecionado
  });

  //console.log("PARAM", params)
  return apiV3.get(`/Endereco/enderecodetalhado${params}`)
    .then((response) => response.data) // Retorna apenas os dados
    .catch((error) => {
      console.error('Erro ao buscar endereço detalhado:', error);
      throw error; // Propaga o erro para ser tratado no componente
    });
};



//PARA BUSCAR PLACEID PARTE 1
// action que apenas busca o place_id e devolve ao componente
export const fetchPlaceId = (input) => {
  return async dispatch => {
    const placeId = await buscarPlaceIdEstabelecimento(input);
    return placeId;    // pode ser string ou null
  };
};


//PARA BUSCAR PLACEID DO GOOGLE PARA FORMAR QRCODE: PARTE 2
export const buscarPlaceIdEstabelecimento = (input) => {
  const params = paramsApi({
    input: input,
    pais: null,
    idioma: null // ID do lugar selecionado
  });
  return apiV3.get(`/Endereco/buscarplaceid${params}`)
    .then(response => {
      if (response.data?.place_id) {
        return response.data.place_id;
      } else {
        throw new Error('PlaceId não encontrado');
      }
    })
    .catch(error => {
      console.error('Erro ao buscar PlaceId:', error);
      return null; // importante: se der erro, retorna null
    });
};



export const listarMeusProjetosEstabelecimentos = (params, controlarLoading = true) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState;
    const { meuProjeto } = getState().meusProjetosState;
    const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`);

    try {
      if (controlarLoading) {
        dispatch(loading());
      }

      const requestParams = {
        ...meuProjeto.estabelecimentosPaginate,
        ...params,
        idProjeto: params.idProjeto
      };

      let response;
    
      if (!meuProjeto.estabelecimentosPaginate?.totalElements) {
        response = await api.get(`/Estabelecimento/ListaEstabelecimentos${paramsApi(params)}`);
      } else {
        console.log("numempresas2", meuProjeto.empresas.length);
        response = await api.get(`/Estabelecimento/ListaEstabelecimentos${paramsApi(requestParams)}`);
      }

      if (!response.data) {
        throw new Error('Resposta da API vazia');
      }

      const lista = response.data.lojas || response.data.informacaoEstabelecimento || [];
      
      await dispatch(setFormProjetoLista({
        name: 'estabelecimentos',
        value: lista
      }));

      await dispatch(setFormProjetoLista({
        name: 'estabelecimentosPaginate',
        value: {
          ...meuProjeto.estabelecimentosPaginate,
          ...response.data.paginacao,
          pageNumber: params.pageNumber || meuProjeto.estabelecimentosPaginate.pageNumber
        }
      }));

      return lista;

    } catch (error) {
      console.error('Erro ao listar estabelecimentos:', error);
      
      if (error.response?.data?.iderro === 999) {
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[29],
            show: true,
            btnAction: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
            btnClose: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
          })
        );
      } else if (error.message !== 'Resposta da API vazia') {
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7],
            show: true,
            btnAction: () => dispatch(modalAlertaClean()),
          })
        );
      }

      throw error;

    } finally {
      if (controlarLoading) {
        dispatch(loaded());
      }
    }
  };
};





export const listarMeusProjetosEstabelecimentosOLD33 = (params) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState;
    const { meuProjeto } = getState().meusProjetosState; // Adiciona esta linha
    const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`);

    try {
      // 1. Inicia o estado de loading
      dispatch(loading());

      // Prepara os parâmetros da requisição garantindo os valores mínimos
      const requestParams = {
        ...meuProjeto.estabelecimentosPaginate, // Pega o estado atual
        ...params,                              // Sobrescreve com os parâmetros recebidos
        idProjeto: params.idProjeto             // Garante que o idProjeto está presente
      };


      // 2. Faz a chamada API e ESPERA a resposta
      //const response = await api.get(`/Estabelecimento/ListaEstabelecimentos${paramsApi(params)}`);
      //const response = await api.get(`/Estabelecimento/ListaEstabelecimentos${paramsApi(requestParams)}`);

      let response;
    
      if (!meuProjeto.estabelecimentosPaginate?.totalElements) {       
          // Se totalElements for zero, null ou undefined
          response = await api.get(`/Estabelecimento/ListaEstabelecimentos${paramsApi(params)}`);
      } else {
          // Caso contrário (se tiver algum valor)
          console.log("numempresas2", meuProjeto.empresas.length);
          response = await api.get(`/Estabelecimento/ListaEstabelecimentos${paramsApi(requestParams)}`);
      }

      //console.log("responseData", response.data)
      // 3. Verifica se há dados na resposta
      if (!response.data) {        
        throw new Error('Resposta da API vazia');
      }
      


      // 4. Processa os dados da resposta
      const lista = response.data.lojas || response.data.informacaoEstabelecimento || [];
      
      // 5. Atualiza o estado com os estabelecimentos
      await dispatch(setFormProjetoLista({
        name: 'estabelecimentos',
        value: lista
      }));

      // 6. Atualiza a paginação
      await dispatch(setFormProjetoLista({
        name: 'estabelecimentosPaginate',

        //A OPÇÃO ABAIXO SEMPRE VOLTAVA PARA PÁGINA 1 DEPOIS DE REALIZAR VERIFICAÇÃO
        /*
        value: {
          ...paginateInit(),
          ...(response.data.paginacao || {})
        }
        */

        //A OPÇÃO ABAIXO, MANTEM A PÁGINA ATUAL DEPOIS DE REALIZAR VERIFICAÇÃO,                
        value: {
          ...meuProjeto.estabelecimentosPaginate, // Mantém o estado atual
          ...response.data.paginacao,               // Atualiza com novos dados
          pageNumber: params.pageNumber || meuProjeto.estabelecimentosPaginate.pageNumber
        }

      }));

      // 7. Retorna os dados para uso posterior
      return lista;

    } catch (error) {
      console.error('Erro ao listar estabelecimentos:', error);
      
      // Tratamento específico para erro 999 (sessão expirada)
      if (error.response?.data?.iderro === 999) {
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[29],
            show: true,
            btnAction: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
            btnClose: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
          })
        );
      } else if (error.message !== 'Resposta da API vazia') {
        // Outros erros
        //console.log("erroxxx123")
        //console.log("erroxxx123MSG", error.message)
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7],
            show: true,
            btnAction: () => dispatch(modalAlertaClean()),
          })
        );
      }

      // Propaga o erro para quem chamou
      throw error;

    } finally {
      // 8. Garante que o loading é finalizado mesmo em caso de erro
      dispatch(loaded());
    }
  };
};

//Erro: quando mudava o idioma, perdia a paginação da página de estabelecimentos
// e mostrava todos os estabelecimentos de uma vez em uma única página
// isso acontecia porque quando mudava o idioma, o payload era apenas o projeto id. 
export const listarMeusProjetosEstabelecimentosOLD = (params) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState;
    const { meuProjeto } = getState().meusProjetosState; // Adiciona esta linha
    const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`);

    try {
      // 1. Inicia o estado de loading
      dispatch(loading());

      // 2. Faz a chamada API e ESPERA a resposta
      const response = await api.get(`/Estabelecimento/ListaEstabelecimentos${paramsApi(params)}`);
      
      // 3. Verifica se há dados na resposta
      if (!response.data) {
        throw new Error('Resposta da API vazia');
      }

      // 4. Processa os dados da resposta
      const lista = response.data.lojas || response.data.informacaoEstabelecimento || [];
      
      // 5. Atualiza o estado com os estabelecimentos
      await dispatch(setFormProjetoLista({
        name: 'estabelecimentos',
        value: lista
      }));

      // 6. Atualiza a paginação
      await dispatch(setFormProjetoLista({
        name: 'estabelecimentosPaginate',

        //A OPÇÃO ABAIXO SEMPRE VOLTAVA PARA PÁGINA 1 DEPOIS DE REALIZAR VERIFICAÇÃO
        
        value: {
          ...paginateInit(),
          ...(response.data.paginacao || {})
        }
        

        //A OPÇÃO ABAIXO, MANTEM A PÁGINA ATUAL DEPOIS DE REALIZAR VERIFICAÇÃO, 
        /*               
        value: {
          ...meuProjeto.estabelecimentosPaginate, // Mantém o estado atual
          ...response.data.paginacao,               // Atualiza com novos dados
          pageNumber: params.pageNumber || meuProjeto.estabelecimentosPaginate.pageNumber
        }
          */

      }));

      // 7. Retorna os dados para uso posterior
      return lista;

    } catch (error) {
      console.error('Erro ao listar estabelecimentos:', error);
      
      // Tratamento específico para erro 999 (sessão expirada)
      if (error.response?.data?.iderro === 999) {
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[29],
            show: true,
            btnAction: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
            btnClose: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
          })
        );
      } else if (error.message !== 'Resposta da API vazia') {
        // Outros erros
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7],
            show: true,
            btnAction: () => dispatch(modalAlertaClean()),
          })
        );
      }

      // Propaga o erro para quem chamou
      throw error;

    } finally {
      // 8. Garante que o loading é finalizado mesmo em caso de erro
      dispatch(loaded());
    }
  };
};





// Função auxiliar para verificar se só tem idProjeto
function paramsOnlyHasIdProjeto(params) {
  const keys = Object.keys(params || {});
  return keys.length === 1 && keys[0] === 'idProjeto';
}


export const listarMeusProjetosEstabelecimentosOLDX = e => {
  const params = paramsApi(e)
  return (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`)

    api.get(`/Estabelecimento/ListaEstabelecimentos${params}`)
    .then(result => {
      if (result.data) {
        const lista = result.data.lojas ? result.data.lojas : result.data.informacaoEstabelecimento
        dispatch([
          setFormProjetoLista({name: 'estabelecimentos', value: lista}),
          setFormProjetoLista({name: 'estabelecimentosPaginate', value: {...paginateInit(), ...result.data.paginacao}})
        ])
      }
    })
    .catch(err => {
        console.error(err, 'listarMeusProjetosEstabelecimentos');
        if (err.response.data.iderro === 999) {
          dispatch(
            modalAlertaInfo({
              ...nlsPopup[29],
              show: true,
              btnAction: () => {
                history.push('/login')
                dispatch(modalAlertaClean())
              },
              btnClose: () => {
                history.push('/login')
                dispatch(modalAlertaClean())
              },
            })
          )
        }
        
    });
  }
}

export const ativarInativaprojeto = (e, nlsPopup, usuarioMaster) => {
 
  //console.log("TESTE NLSPOPUP", nlsPopup[7])
  const urlAcao = e.statusBolean?'Inativaprojeto':'Ativaprojeto'
  return dispatch => {
    dispatch(loading())
    api.put(`/Projeto/${urlAcao}?idProjeto=${e.idProjeto}`)
    .then(result => {
      dispatch(putListMeuProjeto(result.data?.result?result.data?.result:result.data))
      if (urlAcao === 'Inativaprojeto') {
        dispatch(AddAlert('success', nlsPopup.mensagens.inativadocomsucesso));
      } else if (urlAcao === 'Ativaprojeto') {
        dispatch(AddAlert('success', nlsPopup.mensagens.ativadocomsucesso));
      }
    })
    .catch(({response: {data}}) => {
      dispatch(modalClose())
      if (data?.iderro) {

        // Construindo o texto dinamicamente com base nos valores de `data.complemento`
        const creditosfaltantes = [
          data.complemento.projetos !== undefined ? `<br />-${nlsPopup.projetos}: ${data.complemento.projetos}` : '',
          data.complemento.empresas !== undefined ? `<br />-${nlsPopup.empresas}: ${data.complemento.empresas}` : '',
          data.complemento.estabelecimentos !== undefined ? `<br />-${nlsPopup.estabelecimentos}: ${data.complemento.estabelecimentos}` : '',
          data.complemento.produtos !== undefined ? `<br />-${nlsPopup.produtos}: ${data.complemento.produtos}` : ''
        ].join(''); // Junta os textos válidos

        dispatch(modalAlertaInfo({
          ...nlsPopup[usuarioMaster ? '101' : '101a'], // Define a chave correta baseada no usuarioMaster
          btnAction: usuarioMaster
            ? () => dispatch([
                modalAlertaClean(),
                dispatch(modalOpen('assinaturas-adquirir-ativos'))
              ])
            : () => dispatch(modalAlertaClean()), // Apenas fecha o alerta se não for usuário master

          show: true,
          textos: {
            creditosfaltantes: creditosfaltantes,
          }
        }));
      } else {
        dispatch(modalAlertaInfo({
          ...nlsPopup['7'], 
          btnAction: ()=> dispatch(modalAlertaClean()),
          show: true,
        }))
      }
    })
    .finally(()=> {
      dispatch(loaded())
    })
  }
}



export const listarMeusProjetosProdutos = (params, controlarLoading = true) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState;
    const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`);

    try {
      if (controlarLoading) {
        dispatch(loading());
      }

      const response = await api.get(`/Produto/ListaProdutos${paramsApi(params)}`);
      
      if (!response.data) {
        throw new Error('Resposta da API vazia');
      }

      const lista = response.data.lista || response.data.produtos || [];
      
      await dispatch(setFormProjetoLista({
        name: 'produtos',
        value: lista
      }));

      await dispatch(setFormProjetoLista({
        name: 'produtosPaginate',
        value: {
          ...paginateInit(),
          ...(response.data.paginacao || {})
        }
      }));

      return lista;

    } catch (error) {
      console.error('Erro ao listar produtos:', error);
      
      if (error.response?.data?.iderro === 999) {
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[29],
            show: true,
            btnAction: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
            btnClose: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
          })
        );
      } else if (error.message !== 'Resposta da API vazia') {
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7],
            show: true,
            btnAction: () => dispatch(modalAlertaClean()),
          })
        );
      }

      throw error;

    } finally {
      if (controlarLoading) {
        dispatch(loaded());
      }
    }
  };
};



export const listarMeusProjetosProdutosOLD33 = (params) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState;
    const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`);

    try {
      // 1. Inicia o estado de loading
      dispatch(loading());

      // 2. Faz a chamada API e ESPERA a resposta
      const response = await api.get(`/Produto/ListaProdutos${paramsApi(params)}`);
      
      // 3. Verifica se há dados na resposta
      if (!response.data) {
        throw new Error('Resposta da API vazia');
      }

      // 4. Processa os dados da resposta
      const lista = response.data.lista || response.data.produtos || [];
      
      // 5. Atualiza o estado com os produtos
      await dispatch(setFormProjetoLista({
        name: 'produtos',
        value: lista
      }));

      // 6. Atualiza a paginação
      await dispatch(setFormProjetoLista({
        name: 'produtosPaginate',
        value: {
          ...paginateInit(),
          ...(response.data.paginacao || {})
        }
      }));

      // 7. Retorna os dados para uso posterior
      return lista;

    } catch (error) {
      console.error('Erro ao listar produtos:', error);
      
      // Tratamento específico para erro 999 (sessão expirada)
      if (error.response?.data?.iderro === 999) {
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[29],
            show: true,
            btnAction: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
            btnClose: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
          })
        );
      } else if (error.message !== 'Resposta da API vazia') {
        // Outros erros
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7],
            show: true,
            btnAction: () => dispatch(modalAlertaClean()),
          })
        );
      }

      // Propaga o erro para quem chamou
      throw error;

    } finally {
      // 8. Garante que o loading é finalizado mesmo em caso de erro
      dispatch(loaded());
    }
  };
};

export const listarMeusProjetosProdutosOLDX = e => {
  const params = paramsApi(e)
  return (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`)

    api.get(`/Produto/ListaProdutos${params}`)
    .then(result => {
      if (result.data) {
        console.warn(result.data, e, 'listarMeusProjetosProdutos');
        const lista = result.data.lista ? result.data.lista : result.data.produtos
        dispatch([
          setFormProjetoLista({name: 'produtos', value: lista}),
          setFormProjetoLista({name: 'produtosPaginate', value: {...paginateInit(), ...result.data.paginacao}})
        ])
      }
    })
    .catch(err => {
        console.error(err, 'listarMeusProjetos');
        if (err.response.data.iderro === 999) {
          dispatch(
            modalAlertaInfo({
              ...nlsPopup[29],
              show: true,
              btnAction: () => {
                history.push('/login')
                dispatch(modalAlertaClean())
              },
              btnClose: () => {
                history.push('/login')
                dispatch(modalAlertaClean())
              },
            })
          )
        }
    });
  }
}

// const meuProjeto = {gruposProdutos: []}

// export const adicionarMeusProjetosGrupo = e => {
//   console.log(e, 'adicionarMeusProjetosGrupo');
//   return dispatch => {
//     if (e.nome) {
//       dispatch(setFormProjetoLista({name: 'gruposProdutos', value: [...meuProjeto.gruposProdutos, {...e, id: numberAleatori()}]}))
//     }
//   }
// } 

// export const editarMeusProjetosGrupo = e => {
//   console.log(e, 'editarMeusProjetosGrupo');
//   return dispatch => {
//     if (e.nome) {
//       const list = meuProjeto.gruposProdutos.map(g=> Number(g.id) === Number(e.id) ? {...g, ...e} : g)
//       dispatch(setFormProjetoLista({name: 'gruposProdutos', value: list}))
//     }
//   }
// } 

// export const removerMeusProjetosGrupo = e => {
//   console.log(e, 'removerMeusProjetosGrupo');
//   return dispatch => {
//     const list = meuProjeto.gruposProdutos.filter(g=> Number(g.id) !== Number(e.id))
//     dispatch(setFormProjetoLista({name: 'gruposProdutos', value: list}))
//   } 
// }


export const criarProjeto = (e, c, nlsPopup) => {
  const params = {
    "nomeProjeto": e.nome,
    "idSegmento": e.segmento.id,
    "idIcone": Number(e.icone.replace('.png', '')),
    "descricaoLongaProjeto": e.descricao
  }
  
  return async dispatch => {
    dispatch(loading())
    try {
      const { data } = await api.post(`/Projeto/CriaProjeto`, params)
      
      if (data?.result) {
        dispatch(setListMeuProjeto(e))
        dispatch(modalClose())
        
        // Aguarda a atualização da lista de projetos
        await dispatch(listarMeusProjetos(data.result.idProjeto, nlsPopup))
        await dispatch(verificaCreditoConta())
        
        // Redireciona diretamente para empresas
        history.push(`/myprojects/${data.result.idProjeto}/configure/companies`)
        
        dispatch(AddAlert('success', nlsPopup.mensagens.salvarSucesso))
      } else {
        console.error('err', 'criarProjeto');
        dispatch(modalClose())
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7],
            btnAction: () => dispatch(modalAlertaClean()),
            show: true,
          })
        )
      }
    } catch (err) {
      console.error(err, 'criarProjeto Catch');
      dispatch(modalClose())
      dispatch(
        modalAlertaInfo({
          ...nlsPopup[7],
          btnAction: () => dispatch(modalAlertaClean()),
          show: true,
        })
      )
    } finally {
      dispatch(loaded())
    }
  }
}

//SOLUÇÃO ANTIGA QUE NÃO FUNCIONAVA DIREITO PORQUE DAVA PROBLEMA DE TIMING...
export const criarProjetoOLD = (e, c, nlsPopup) => {
  const params = {
    "nomeProjeto": e.nome,
    "idSegmento": e.segmento.id,
    "idIcone": Number(e.icone.replace('.png', '')),
    "descricaoLongaProjeto": e.descricao
  }
  return dispatch => {
    dispatch(loading())
    api.post(`/Projeto/CriaProjeto`, params)
    .then(({data}) => {
      if (data?.result) {
        dispatch(setListMeuProjeto(e))
        dispatch(modalClose())
        //dispatch(listarMeusProjetos('', nlsPopup))
        dispatch(listarMeusProjetos(data.result.idProjeto, nlsPopup))
        dispatch(verificaCreditoConta())
/*
        if (c && data?.result?.idProjeto) {
          setTimeout(() => {
            //history.push(`/meusprojetos/${data?.result?.idProjeto}/configurar/empresas`)
            history.push(`/myprojects/${data?.result?.idProjeto}/configure/empresas`)
          }, 600);
        }
*/
        //console.log("IDNOVOPROJETO",data.result.idProjeto)
        if (data.result.idProjeto) {
          //console.log("ENTROU NO LOOP IDNOVOPROJETO")
          //console.log("IDNOVOPROJETO - LOCATION ATUAL", window.location.href);
          history.push(`/myprojects/${data.result.idProjeto}/configure/companies`)
           
          //console.log("IDNOVOPROJETO - LOCATION DEPOIS DO PUSH", window.location.href);
        }

        dispatch(AddAlert('success', nlsPopup.mensagens.salvarSucesso))
      } else{
        console.error('err', 'criarProjeto');

        //FECHA O POPUP COM OS DADOS
        dispatch(modalClose()) 

        //ABRE O POPUP COM MENSAGEM DE ERRO
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7], // Inclui o conteúdo de nlsPopup[12]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )


        
      }
    })
    .catch(err => {
        console.error(err, 'criarProjeto Catch');
        
        //FECHA O POPUP COM OS DADOS
        dispatch(modalClose())
        //ABRE O POPUP COM MENSAGEM DE ERRO
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7], // Inclui o conteúdo de nlsPopup[12]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

    })
    .finally(()=> {
      dispatch(loaded())
    })
  }
}

export const editarProjeto = (e, nlsPopup) => {
  const params = {
    "idProjeto": e.idProjeto,
    "nomeProjeto": e.nome,
    "idIcone": Number(e.icone.replace('.png', '')),
    "descricaoLongaProjeto": e.descricao
  }
  return dispatch => {
    dispatch(loading())
    api.put(`/Projeto/EditaProjeto`, params)
    .then(result => {
      if (result?.data) {
        const resp = {
          "idProjeto": e.idProjeto,
          "descricao": e.nome,
          "idIcone": e.icone,
          'icone': e.icone, 
          "descricaoLonga": e.descricao
        }
        dispatch(putListMeuProjeto(resp))
        dispatch(verificaCreditoConta())
        dispatch(AddAlert('success', nlsPopup.mensagens.editarSucesso))
      } else{
        console.error('erro', 'editarProjeto');
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7], // Inclui o conteúdo de nlsPopup[12]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )
      }
    })
    .catch(err => {
        console.error(err, 'editarProjeto');
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7], // Inclui o conteúdo de nlsPopup[12]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )
    })
    .finally(()=> {
      dispatch(loaded())
    })
  }
}



// Registra que o usuário não quer mais ver um popup específico de criar empresa
export const registraNaoReceberPopups = (qualpopup /* ex.: "NaoReceberCriaEmpresa" */) => {
  return async (dispatch) => {
    dispatch(loading());
    try {
      await api.post(`/Usuario/RegistraNaoReceberPopups`, null, { params: { qualpopup } });
    } catch (err) {
      console.error(err, 'registraNaoReceberPopups');
    } finally {
      dispatch(loaded());
    }
  };
};





export const criarEmpresa = e => {
  console.log('Dados recebidos em criarEmpresa:', e); // DEBUG
  
  const params = {
    "projetoId": e.projetoId,
    "nomeEmpresa": e.nomeEmpresa,
    "urlFacebookEmpresa": e.urlFacebookEmpresa || '',
    "urlInstagramEmpresa": e.urlInstagramEmpresa || '',
    "urlTwitterEmpresa": e.urlTwitterEmpresa || '',
    "urlYoutubeEmpresa": e.urlYoutubeEmpresa || '',
    "urlTiktokEmpresa": e.urlTiktokEmpresa || '',
    "hashtags": e.hashtags || [] // Garantir que sempre seja um array
  }
  
  console.log('Params sendo enviados para API:', params); // DEBUG
  
  return dispatch => {

    dispatch(loading())

    api.post(`/Empresa/CriaEmpresa`, params)
    .then(({data}) => {
      console.log('Resposta da API:', data); // DEBUG
      if (data?.result) {
        dispatch(listarMeusProjetosEmpresas({...paginateInit(), idProjeto: e.projetoId}))
        dispatch(verificaCreditoConta())
        dispatch(AddAlert('success', e.nlsPopup.mensagens.criadocomsucesso))
      } else{
        console.error('err', 'criarEmpresa');
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7],
            show: true,          
          })
        )
      }
    })
    .catch(err => {
        console.error(err, 'criarEmpresa');
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7],
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true,          
          })
        )
    })
    .finally(()=> {
      dispatch(loaded())
    })
  }
}




export const criarEmpresaORIGINALOKSEMHASHTAGS = e => {
  const params = {
    "projetoId": e.projetoId,
    "nomeEmpresa": e.nomeEmpresa,
    "urlFacebookEmpresa": e.urlFacebookEmpresa?e.urlFacebookEmpresa:'',
    "urlInstagramEmpresa": e.urlInstagramEmpresa?e.urlInstagramEmpresa:'',
    "urlTwitterEmpresa": e.urlTwitterEmpresa?e.urlTwitterEmpresa:'',
    "urlYoutubeEmpresa": e.urlYoutubeEmpresa?e.urlYoutubeEmpresa:'',
    "urlTiktokEmpresa": e.urlTiktokEmpresa?e.urlTiktokEmpresa:'',
  }
  return dispatch => {
    //console.log("nlsPopup", e.nlsPopup);

    dispatch(loading())

    api.post(`/Empresa/CriaEmpresa`, params)
    .then(({data}) => {
      if (data?.result) {
        // dispatch(setListMeuProjetoTab({name: 'empresas', value: data?.resut, id: 'empresaId'}))
        dispatch(listarMeusProjetosEmpresas({...paginateInit(), idProjeto: e.projetoId}))
        dispatch(verificaCreditoConta())
        dispatch(AddAlert('success', e.nlsPopup.mensagens.criadocomsucesso))
      } else{
        console.error('err', 'criarEmpresa');
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            show: true, // Garante que o modal será exibido          
          })
        )

      }
    })
    .catch(err => {
        console.error(err, 'criarEmpresa');
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

    })
    .finally(()=> {
      dispatch(loaded())
    })
  }
}



export const importarEmpresa = ({ file, nlsPopup, projetoId, usuarioMaster }) => {
  const formData = new FormData();
  
  formData.append('file', file)
  console.log("VALOR nls\popup[7]", nlsPopup[7])
  

  //return dispatch => {
    return (dispatch, getState) => {
    dispatch(loading())
    api.post(`/Empresa/CriaEmpresasEmMassa?projetoId=${projetoId}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(result => {
      if (result?.data) {
        // dispatch(setListMeuProjetoTab({name: 'empresas', value: {...params, id: idRdm()}, id: 'empresaId'}))
        dispatch(listarMeusProjetosEmpresas({...paginateInit(), idProjeto: projetoId}))
        dispatch(verificaCreditoConta())
        dispatch(AddAlert('success', nlsPopup.mensagens.criadocomsucesso))
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[13], // 
            show: false, // Garante que o modal de aviso será fechado
            btnAction: () => dispatch(modalAlertaClean()), // Define a ação no botão de confirmação
            
          })
        )

        const { sistema } = getState().layoutState;
        if (sistema?.login?.recebePopupCriaEmpresa) {
          dispatch(
            modalAlertaInfo({
              ...nlsPopup[118],
              show: true,
              btnAction: async () => {
                try {
                  await dispatch(registraNaoReceberPopups("NaoReceberCriaEmpresa"));
                } finally {
                  dispatch(setRecebePopupCriaEmpresa(false)); // atualiza store local
                  dispatch(modalAlertaClean());               // fecha popup
                }
              },
            })
          );
        }

      } else{
        console.error('err', 'importarEmpresa');
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7], // Inclui o conteúdo de nlsPopup[12]
            show: true, // Garante que o modal será exibido          
          })
        )

      }
      dispatch(modalClose())
    })
    .catch(({response: {data}}) => {
      dispatch(modalClose())
      if (data?.iderro) {
        dispatch(modalAlertaInfo({
          ...nlsPopup[usuarioMaster ? '102' : '102a'], // Define a chave correta baseada no usuarioMaster
          btnAction: usuarioMaster
            ? () => dispatch([
                modalAlertaClean(),
                modalOpen('assinaturas-adquirir-ativos')
              ])
            : () => dispatch(modalAlertaClean()), // Apenas fecha o alerta se não for usuário master
      
          show: true,
        }));
      } else {
        dispatch(modalAlertaInfo({
          ...nlsPopup['7'], 
          btnAction: ()=> dispatch(modalAlertaClean()),
          show: true,
        }))
      }
    })

    .finally(()=> {
      dispatch(loaded())
    })
  }
}


// editarEmpresa atualizado
export const editarEmpresaOLDCHAT = e => {
  const params = {
    "projetoId": e.projetoId,
    "empresaId": e.empresaId,
    "nomeEmpresa": e.nomeEmpresa,
    "urlFacebookEmpresa": e.urlFacebookEmpresa?e.urlFacebookEmpresa:'',
    "urlInstagramEmpresa": e.urlInstagramEmpresa?e.urlInstagramEmpresa:'',
    "urlTwitterEmpresa": e.urlTwitterEmpresa?e.urlTwitterEmpresa:'',
    "urlYoutubeEmpresa": e.urlYoutubeEmpresa?e.urlYoutubeEmpresa:'',
    "urlTiktokEmpresa": e.urlTiktokEmpresa?e.urlTiktokEmpresa:'',
    "hashtagsAdicionar": e.hashtagsAdicionar || [],
    "hashtagsRemover": e.hashtagsRemover || []
  }
  
  return dispatch => {

    dispatch(loading())
    api.put(`/Empresa/EditaEmpresa`, params)
    .then(result => {
      if (result?.data) {
        dispatch(listarMeusProjetosEmpresas({...paginateInit(), idProjeto: e.projetoId}))
        dispatch(verificaCreditoConta())
        dispatch(AddAlert('success', e.nlsPopup.mensagens.editadocomsucesso))
      } else{
        console.error('err', 'editarEmpresa');
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7],
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true,          
          })
        )
      }
    })
    .catch(err => {
        console.error(err, 'editarEmpresa');
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7],
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true,          
          })
        )
    })
    .finally(()=> {
      dispatch(loaded())
    })
  }
}


export const editarEmpresa = e => {
  const params = {
    projetoId: e.projetoId,
    empresaId: e.empresaId,
    nomeEmpresa: e.nomeEmpresa,
    urlFacebookEmpresa: e.urlFacebookEmpresa ? e.urlFacebookEmpresa : '',
    urlInstagramEmpresa: e.urlInstagramEmpresa ? e.urlInstagramEmpresa : '',
    urlTwitterEmpresa: e.urlTwitterEmpresa ? e.urlTwitterEmpresa : '',
    urlYoutubeEmpresa: e.urlYoutubeEmpresa ? e.urlYoutubeEmpresa : '',
    urlTiktokEmpresa: e.urlTiktokEmpresa ? e.urlTiktokEmpresa : '',
    hashtags: e.hashtags || []
  }

  return async dispatch => {
    try {
      dispatch(loading())

      const result = await api.put(`/Empresa/EditaEmpresa`, params)

      if (result?.data) {
        await dispatch(listarMeusProjetosEmpresas({ ...paginateInit(), idProjeto: e.projetoId }))
        await dispatch(verificaCreditoConta())
        dispatch(AddAlert('success', e.nlsPopup.mensagens.editadocomsucesso))
      } else {
        console.error('err', 'editarEmpresa')
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7],
            btnAction: () => dispatch(modalAlertaClean()),
            show: true,
          })
        )
      }
    } catch (err) {
      console.error(err, 'editarEmpresa')
      dispatch(
        modalAlertaInfo({
          ...e.nlsPopup[7],
          btnAction: () => dispatch(modalAlertaClean()),
          show: true,
        })
      )
    } finally {
      dispatch(loaded())
    }
  }
}


export const editarEmpresaOLD = e => {
  const params = {
    "projetoId": e.projetoId,
    "empresaId": e.empresaId,
    "nomeEmpresa": e.nomeEmpresa,
    "urlFacebookEmpresa": e.urlFacebookEmpresa?e.urlFacebookEmpresa:'',
    "urlInstagramEmpresa": e.urlInstagramEmpresa?e.urlInstagramEmpresa:'',
    "urlTwitterEmpresa": e.urlTwitterEmpresa?e.urlTwitterEmpresa:'',
    "urlYoutubeEmpresa": e.urlYoutubeEmpresa?e.urlYoutubeEmpresa:'',
    "urlTiktokEmpresa": e.urlTiktokEmpresa?e.urlTiktokEmpresa:'',
    "hashtags": e.hashtags || []
  }
  return dispatch => {
    api.put(`/Empresa/EditaEmpresa`, params)
    .then(result => {
      if (result?.data) {
        dispatch(listarMeusProjetosEmpresas({...paginateInit(), idProjeto: e.projetoId}))
        // dispatch(putListMeuProjetoTab({name: 'empresas', value: params, id: 'empresaId'}))
        dispatch(verificaCreditoConta())
        dispatch(AddAlert('success', e.nlsPopup.mensagens.editadocomsucesso))
      } else{
        console.error('err', 'editarEmpresa');
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

      }
    })
    .catch(err => {
        console.error(err, 'editarEmpresa');
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

    });
  }
}

export const removerEmpresa = (e, idProjeto, nlsPopup) => {
  const params = e
  return dispatch => {
    api.put(`/Empresa/AgendaDeleteEmpresas`, params)
    .then(result => {
      if (result?.data) {    
        dispatch(listarMeusProjetosEmpresas({...paginateInit(), idProjeto}))
        dispatch(verificaCreditoConta())
        // e.map(id=> {
        //   dispatch(removeListMeuProjetoTab({id, name: 'empresas'}))
        // })
      } else{
        console.error('err', 'removerEmpresa');
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

      }
    })
    .catch(err => {
        console.error(err, 'removerEmpresa');
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

    });
  }
}


export const criarProduto = e => {
  const params = {
    ...(e.nomeEmpresa.empresaId && { "empresaId": e.nomeEmpresa.empresaId }),
    ...(e.subSegmento.idSubSegmento && { "subSegmentoId": e.subSegmento.idSubSegmento }),
    ...(e.grupoProduto.idGrupoProduto && { "grupoProdutoId": e.grupoProduto.idGrupoProduto }),
    "nomeProduto": e.nomeProduto,
    "urlAmazonProduto": e.urlAmazonProduto,
  }
  //return dispatch => {
    return (dispatch, getState) => {
    dispatch(loading())
    api.post(`/Produto/criaProduto`, params)
    .then(result => {
      if (result?.data) {
        dispatch(listarMeusProjetosProdutos({...paginateInit(), idProjeto: e.projetoId}))
        dispatch(verificaCreditoConta())
        dispatch(AddAlert('success', e.nlsPopup.mensagens.criadocomsucesso))
        // dispatch(setListMeuProjetoTab({name: 'produtos', value: {...params, id: idRdm()}, id: 'idProduto'}))
      
        
        const { sistema } = getState().layoutState;
        //console.log("recebePopupCriaProduto", sistema?.login?.recebePopupCriaProduto)
        //console.log("recebePopupCriaProdutoNLSPOPUP117", e.nlsPopup[117])
        
        if (sistema?.login?.recebePopupCriaproduto) {      
          dispatch(
            modalAlertaInfo({
              //...nlsPopup[117],
              ...e.nlsPopup[117],
              show: true,
              btnAction: async () => {
                try {
                  await dispatch(registraNaoReceberPopups("NaoReceberCriaProduto"));
                } finally {
                  dispatch(setRecebePopupCriaProduto(false)); // atualiza store local
                  dispatch(modalAlertaClean());               // fecha popup
                }
              },
            })
          );
        }

        
      } else{
        console.error('err', 'criarProduto');
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            show: true, // Garante que o modal será exibido          
          })
        )

      }
    })
    .catch(({response: {data}}) => {
      dispatch(modalClose())
      if (data?.iderro) {
        dispatch(modalAlertaInfo({
          ...e.nlsPopup['105'], 
          btnAction: ()=> dispatch(modalAlertaClean()),
          show: true, 
        }))
      } else {
        dispatch(modalAlertaInfo({
          ...e.nlsPopup['7'], 
          btnAction: ()=> dispatch(modalAlertaClean()),
          show: true,
        }))
      }
    })
    .finally(()=> {
      dispatch(loaded())
    })
  }
}

export const importarProduto = e => {
  const formData = new FormData();
  
  formData.append('file', e.file)

  //return dispatch => {
    return (dispatch, getState) => {
    dispatch(loading())
    api.post(`/Produto/CriaProdutosEmMassa?projetoId=${e.projetoId}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(result => {
      if (result?.data) {
        //COLOCADO PARA ATUALIZAR GRUPOS       
        dispatch(listarGruposProdutos(e.projetoId));        
        dispatch(listarMeusProjetosProdutos({...paginateInit(), idProjeto: e.projetoId}))
        dispatch(verificaCreditoConta())
        dispatch(AddAlert('success', e.nlsPopup.mensagens.criadocomsucesso))
        dispatch(modalAlertaClean())

        const { sistema } = getState().layoutState;
        if (sistema?.login?.recebePopupCriaproduto) {      //recebePopupCriaproduto
          dispatch(
            modalAlertaInfo({
              //...nlsPopup[117],
              ...e.nlsPopup[117],
              show: true,
              btnAction: async () => {
                try {
                  await dispatch(registraNaoReceberPopups("NaoReceberCriaProduto"));     //NaoReceberCriaProduto
                } finally {
                  dispatch(setRecebePopupCriaProduto(false)); // atualiza store local
                  dispatch(modalAlertaClean());               // fecha popup
                }
              },
            })
          );
        }

      } else{
        console.error('err', 'importarProduto');
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            show: true, // Garante que o modal será exibido          
          })
        )

      }
      dispatch(modalClose())
    })
    .catch(({response: {data}}) => {
      dispatch(modalClose())
      if (data?.iderro === 106) {
        dispatch(modalAlertaInfo({
          ...e.nlsPopup[e.usuarioMaster ? '106' : '106a'], // Define a chave correta baseada em e.usuarioMaster
          btnAction: e.usuarioMaster
            ? () => dispatch([
                modalAlertaClean(),
                modalOpen('assinaturas-adquirir-ativos')
              ])
            : () => dispatch(modalAlertaClean()), // Apenas fecha o alerta se não for usuário master
      
          show: true, 
        }));
      }
       else if (data?.iderro === 107) {
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup['107'],
            btnAction: () => dispatch(modalAlertaClean()),
            show: true,
            textos: {
              Empresas107: data.complemento,
            }
          })
        );
      } else if (data?.iderro === 108) {
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup['108'],
            btnAction: () => dispatch(modalAlertaClean()),
            show: true,
            textos: {
              Subsegmentos108: data.complemento,
            }
          })
        );
      } else if (data?.iderro === 109) {
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup['109'],
            btnAction: () => dispatch(modalAlertaClean()),
            show: true,
          })
        );
      } else {
        dispatch(modalAlertaInfo({
          ...e.nlsPopup['7'], 
          btnAction: ()=> dispatch(modalAlertaClean()),
          show: true,
        }))
      }
    })
    .finally(()=> {
      dispatch(loaded())
    })
  }
}

export const editarProduto = e => {
  const params = {
    ...(e.nomeEmpresa.empresaId && { "empresaId": e.nomeEmpresa.empresaId }),
    ...(e.subSegmento.idSubSegmento && { "subSegmentoId": e.subSegmento.idSubSegmento }),
    ...(e.grupoProduto.idGrupoProduto && { "grupoProdutoId": e.grupoProduto.idGrupoProduto }),
    "idProduto": e.idProduto,
    "nomeProduto": e.nomeProduto,
    "urlAmazonProduto": e.urlAmazonProduto,
  }


  
  
  return dispatch => {
    api.put(`/Produto/EditaProduto`, params)
    .then(result => {
      if (result?.data) {
        dispatch(listarMeusProjetosProdutos({...paginateInit(), idProjeto: e.projetoId}))
        // dispatch(putListMeuProjetoTab({name: 'produtos', value: params, id: 'idProduto'}))
        dispatch(verificaCreditoConta())
        dispatch(AddAlert('success', e.nlsPopup.mensagens.editadocomsucesso))
      } else{
        console.error('err', 'editarProduto');
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

      }
    })
    .catch(err => {
        console.error(err, 'editarProduto');
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

    });
  }
}

export const removerProduto = (e, idProjeto, nlsPopup) => {
  const params = e
  return dispatch => {
    api.put(`/Produto/AgendaDeleteProdutos`, params)
    .then(result => {
      if (result?.data) {    
        
        dispatch(listarMeusProjetosProdutos({...paginateInit(), idProjeto}))
        dispatch(verificaCreditoConta())
        // e.map(id=> {
        //   dispatch(removeListMeuProjetoTab({id, name: 'empresas'}))
        // })
      } else{
        console.error('err', 'removerProduto');
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

      }
    })
    .catch(err => {
        console.error(err, 'removerProduto');
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

    });
  }
}


export const criarEstabelecimento = e => {
  const params = {
    "empresaId": e.nomeEmpresa.empresaId,
    "grupoEstabelecimentoId": e.grupoEstabelecimentoId?e.grupoEstabelecimentoId:e.grupoEstabelecimento.idGrupoEstabelecimento,
    "nomeEstabelecimento": e.nomeEstabelecimento,
    "ruaAvenidaRodovia": e.ruaAvenidaRodovia,
    "numero": e.numero,
    "complemento": e.complemento,
    "bairro": e.bairro,
    "cidade": e.cidade,
    "estado": e.estado,
    "cep": e.cep,
    "pais": e.pais,
    "coordenadas": e.coordenadas,
    "urlTripadvisorEstabelecimento": e.urlTripadvisorEstabelecimento?e.urlTripadvisorEstabelecimento:e.urlTripAdvisorEstabelecimento,
    "urlBookingEstabelecimento": e.urlBookingEstabelecimento || '',
  }
  //return dispatch => {
    return (dispatch, getState) => {
    dispatch(loading())
    api.post(`/Estabelecimento/criaEstabelecimento`, params)
    .then(result => {
      if (result?.data) {
        
        dispatch(listarMeusProjetosEstabelecimentos({...paginateInit(), idProjeto: e.projetoId}))
        dispatch(verificaCreditoConta())
        // dispatch(listarMeusProjetosEstabelecimentos(e.projetoId))
        // dispatch(setListMeuProjetoTab({name: 'estabelecimentos', value: {...params, id: idRdm()}, id: 'idEstabelecimento'}))
        dispatch(modalClose())
        dispatch(AddAlert('success', e.nlsPopup.mensagens.criadocomsucesso))

        //Popup de aviso
        const { sistema } = getState().layoutState;
        if (sistema?.login?.recebePopupCriaEstabelecimento) {      //recebePopupCriaEstabelecimento
          dispatch(
            modalAlertaInfo({
              //...nlsPopup[115],
              ...e.nlsPopup[115],
              show: true,
              btnAction: async () => {
                try {
                  await dispatch(registraNaoReceberPopups("NaoReceberCriaEstabelecimento"));     //NaoReceberCriaEstabelecimento
                } finally {
                  dispatch(setRecebePopupCriaEstabelecimento(false)); // atualiza store local
                  dispatch(modalAlertaClean());               // fecha popup
                }
              },
            })
          );
        }

      } else{
        console.error('err', 'criarEstabelecimento');
        dispatch(modalClose())
        dispatch(
          
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

      }
    })
    .catch(err => {
        console.error(err, 'criarEstabelecimento');
        dispatch(modalClose())
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

    })
    .finally(()=> {
      dispatch(loaded())
    })
  }
}

export const importarEstabelecimento = e => {
  const formData = new FormData();
  
  formData.append('file', e.file)

  //return dispatch => {
    return (dispatch, getState) => {
    dispatch(loading())
    api.post(`/Estabelecimento/CriaEstabelecimentosEmMassa?projetoId=${e.projetoId}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(result => {
      if (result?.data) {
        
        dispatch(listarGruposEstabelecimentos(e.projetoId));        
        dispatch(listarMeusProjetosEstabelecimentos({...paginateInit(), idProjeto: e.projetoId}))
        dispatch(verificaCreditoConta())
        dispatch(AddAlert('success', e.nlsPopup.mensagens.criadocomsucesso))
  
        const { sistema } = getState().layoutState;
        if (sistema?.login?.recebePopupCriaEstabelecimento) {      //recebePopupCriaEstabelecimento
          dispatch(
            modalAlertaInfo({
              //...nlsPopup[115],
              ...e.nlsPopup[115],
              show: true,
              btnAction: async () => {
                try {
                  await dispatch(registraNaoReceberPopups("NaoReceberCriaEstabelecimento"));     //NaoReceberCriaEstabelecimento
                } finally {
                  dispatch(setRecebePopupCriaEstabelecimento(false)); // atualiza store local
                  dispatch(modalAlertaClean());               // fecha popup
                }
              },
            })
          );
        }

      } else{
        console.error('err', 'importarEstabelecimento');
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            show: true, // Garante que o modal será exibido          
          })
        )

      }
      dispatch(modalClose())
    })
    .catch(({ response: { data } }) => {
      dispatch(modalClose());
      if (data?.iderro === 103) {
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[e.usuarioMaster ? '103' : '103a'], // Define a chave correta baseada em e.usuarioMaster
            btnAction: e.usuarioMaster
              ? () => dispatch([
                  modalAlertaClean(),
                  modalOpen('assinaturas-adquirir-ativos')
                ])
              : () => dispatch(modalAlertaClean()), // Apenas fecha o alerta se não for usuário master
      
            show: true,
          })
        );
      }
       else if (data?.iderro === 104) {
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup['104'],
            btnAction: () => dispatch(modalAlertaClean()),
            show: true,
            textos: {
              Empresas104: data.complemento,
            }
          })
        );
      } else {
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup['7'],
            btnAction: () => dispatch(modalAlertaClean()),
            show: true,
          })
        );
      }
    })    

    .finally(()=> {
      dispatch(loaded())
    })
  }
}

export const editarEstabelecimento = e => {
  const params = {
    "idEstabelecimento": e.idEstabelecimento,
    "empresaId": e.empresaId,
    "grupoEstabelecimentoId": e.grupoEstabelecimentoId?e.grupoEstabelecimentoId:e.grupoEstabelecimento.idGrupoEstabelecimento,
    "nomeEstabelecimento": e.nomeEstabelecimento,
    "ruaAvenidaRodovia": e.ruaAvenidaRodovia,
    "numero": e.numero,
    "complemento": e.complemento,
    "bairro": e.bairro,
    "cidade": e.cidade,
    "estado": e.estado,
    "cep": e.cep,
    "pais": e.pais,
    "coordenadas": e.coordenadas,
    "urlTripadvisorEstabelecimento": e.urlTripadvisorEstabelecimento?e.urlTripadvisorEstabelecimento:e.urlTripAdvisorEstabelecimento,
    "urlBookingEstabelecimento": e.urlBookingEstabelecimento || '',
  }

  console.log("ENTREOU EM 2", params)
  return dispatch => {
    api.put(`/Estabelecimento/EditaEstabelecimento`, params)
    .then(result => {
      if (result?.data) {
        //console.log("ENTREOU EM 3")
        dispatch(listarMeusProjetosEstabelecimentos({...paginateInit(), idProjeto: e.projetoId}))
        dispatch(verificaCreditoConta())
        // dispatch(listarMeusProjetosEstabelecimentos(e.projetoId))
        // dispatch(putListMeuProjetoTab({name: 'estabelecimentos', value: params, id: 'idEstabelecimento'}))
        dispatch(modalClose())
        dispatch(AddAlert('success', e.nlsPopup.mensagens.editadocomsucesso))
      } else{
        //console.log("ENTREOU EM 4")
        console.error('err', 'editarEstabelecimento');
        dispatch(modalClose())
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

      }
    })
    .catch(err => {
      //console.log("ENTREOU EM 5")
        console.error(err, 'editarEstabelecimento');
        dispatch(modalClose())
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

    });
  }
}

export const removerEstabelecimento = (e, idProjeto, nlsPopup) => {
  const params = e.map(a=> Number(a))
  return dispatch => {
    api.post(`/Estabelecimento/DeletaOuAgendaDeleteEstabelecimentos`, params)
    .then(result => {
      if (result?.data) {   
        dispatch(listarMeusProjetosEstabelecimentos({...paginateInit(), idProjeto}))
        dispatch(verificaCreditoConta())
        // dispatch(listarMeusProjetosEstabelecimentos(projetoId)) 
        // e.map(id=> {
        //   dispatch(removeListMeuProjetoTab({id, name: 'empresas'}))
        // })
      } else{
        console.error('err', 'removerEstabelecimento');
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

      }
    })
    .catch(err => {
        console.error(err, 'removerEstabelecimento');
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

    });
  }
}

export const listarEstabelecimentosVerificar = e => {
  return dispatch => {
    api.get(`/Estabelecimento/ListaVerificacaoEstabelecimentos?IdEstabelecimento=${e}`)
    .then(result => {
      dispatch(setFormProjetoLista({name: 'estabelcimentosVerificar', value: result.data}))
      dispatch(verificaCreditoConta())
    })
    .catch(err => {
        console.error(err, 'listarEstabelecimentosVerificar');
    });
  }
}

export const estabelecimentosVerificar = (e) => {
  return async (dispatch, getState) => { // Adiciona getState como parâmetro
    const { nlsPopup, ...params } = e || {};
    const { meuProjeto } = getState().meusProjetosState;
    const currentPage = meuProjeto.estabelecimentosPaginate.pageNumber;
    
    try {
      const result = await api.put(`/Estabelecimento/VerificaEstabelecimento${paramsApi(params)}`, {});
      
      if (result?.data) {   
        // Recarrega mantendo a página atual
        await dispatch(listarMeusProjetosEstabelecimentos({
          ...meuProjeto.estabelecimentosPaginate,
          idProjeto: e.idProjetos,
          pageNumber: currentPage
        }));
        
        dispatch(verificaCreditoConta());
        dispatch(AddAlert('success', e.nlsPopup.mensagens.verificadocomsucesso));

        const { sistema } = getState().layoutState;
        if (sistema?.login?.recebePopupVerificaEstabelecimento) {      
          dispatch(
            modalAlertaInfo({
              //...nlsPopup[115],
              ...e.nlsPopup[116],
              show: true,
              btnAction: async () => {
                try {
                  await dispatch(registraNaoReceberPopups("NaoReceberVerificaEstabelecimento"));
                } finally {
                  dispatch(setRecebePopupVerificaEstabelecimento(false)); // atualiza store local
                  dispatch(modalAlertaClean());               // fecha popup
                }
              },
            })
          );
        }








        return true;
      }
      
      throw new Error('Resposta da API inválida');
      
    } catch (erro) {
      console.error(erro, 'estabelecimentosVerificar');
      dispatch(
        modalAlertaInfo({
          ...e.nlsPopup[7],
          btnAction: () => dispatch(modalAlertaClean()),
          show: true,
        })
      );
      return false;
    }
  };
};


export const listarGruposProdutos = (e, controlarLoading = true) => {
  return async dispatch => {
    try {
      if (controlarLoading) {
        dispatch(loading())
      }

      const result = await api.get(`/Produto/ListaGruposProdutos?idProjeto=${e}`)

      dispatch(setFormProjetoLista({
        name: 'gruposProdutos',
        value: result.data
      }))

      const respGrupos = result.data.map(g => ({
        ...g,
        id: g.idGrupoProduto,
        name: g.nomeGrupoProduto
      }))

      dispatch(setListarGrupos(respGrupos))
      dispatch(setInfoGrupo(respGrupos[0] || {}))

      return result.data
    } catch (err) {
      console.error(err, 'listarGruposProdutos')
      throw err
    } finally {
      if (controlarLoading) {
        dispatch(loaded())
      }
    }
  }
}



export const listarGruposProdutosOLD33 = e => {
  return dispatch => {
    api.get(`/Produto/ListaGruposProdutos?idProjeto=${e}`)
    .then(result => {
      dispatch(setFormProjetoLista({name: 'gruposProdutos', value: result.data}))

      const respGrupos = result.data.map(g=> ({...g, id: g.idGrupoProduto, name: g.nomeGrupoProduto}))
      dispatch(setListarGrupos(respGrupos))
      dispatch(setInfoGrupo(respGrupos[0]))
    })
    .catch(err => {
        console.error(err, 'listarGruposProdutos');
    });
  }
}

export const criarGrupoProduto = e => {
  const params = {
    "projetoId": e.projetoId,
    "nomeGrupoProduto": e.nomeGrupoProduto
  }
  return dispatch => {
    api.post(`/Produto/CriaGrupoProduto`, params)
    .then(result => {
      if (result.data) {
        dispatch(listarGruposProdutos(e.projetoId))
      } else {
        console.error('erro', 'criarGrupoProduto');
        dispatch(modalClose())
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

      }
    })
    .catch(erro => {
        console.error(erro, 'criarGrupoProduto');
        dispatch(modalClose())
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

    });
  }
}

export const removerGrupoProduto = (e, nlsPopup) => {
  console.log("NLSPOPUP EM GRUPO", nlsPopup)
  return dispatch => {
    api.delete(`/Produto/DeletaGrupoProduto?grupoProdutoID=${e.idGrupoProduto}`)
    .then(result => {
      if (result.data) {
        dispatch(listarGruposProdutos(e.idProjeto))
      } else {
        console.error('erro', 'removerGrupoProduto');
      }
    })
    .catch(({response: {data}}) => {
      dispatch(modalClose())
      if (data?.iderro === 110) {
        dispatch(modalAlertaInfo({
          ...nlsPopup['110'], 
          btnAction: ()=> dispatch(modalAlertaClean()),
          show: true,
        }))
      } 
    });
  }
}


export const listarGruposEstabelecimentos = (e, controlarLoading = true) => {
  return async dispatch => {
    try {
      if (controlarLoading) {
        dispatch(loading())
      }

      const result = await api.get(`/Estabelecimento/ListaGruposEstabelecimentos?idProjeto=${e}`)

      dispatch(setFormProjetoLista({
        name: 'gruposEstabelecimentos',
        value: result.data
      }))

      const respGrupos = result.data.map(g => ({
        ...g,
        id: g.idGrupoEstabelecimento,
        name: g.nomeGrupoEstabelecimento
      }))

      dispatch(setListarGrupos(respGrupos))
      dispatch(setInfoGrupo(respGrupos[0] || {}))

      return result.data
    } catch (err) {
      console.error(err, 'listarGruposEstabelecimentos')
      throw err
    } finally {
      if (controlarLoading) {
        dispatch(loaded())
      }
    }
  }
}


export const listarGruposEstabelecimentosOLD33 = e => {
  return dispatch => {
    api.get(`/Estabelecimento/ListaGruposEstabelecimentos?idProjeto=${e}`)
    .then(result => {
      dispatch(setFormProjetoLista({name: 'gruposEstabelecimentos', value: result.data}))

      const respGrupos = result.data.map(g=> ({...g, id: g.idGrupoEstabelecimento, name: g.nomeGrupoEstabelecimento}))
      dispatch(setListarGrupos(respGrupos))
      dispatch(setInfoGrupo(respGrupos[0]))
    })
    .catch(err => {
      console.error(err, 'listarGruposEstabelecimentos');
    });
  }
}

export const criarGrupoEstabelecimento = e => {
  const params = {
    "projetoId": e.projetoId,
    "nomeGrupoEstabelecimento": e.nome,
    "nlsPopup": e.nlsPopup
    
  }
  return dispatch => {
    api.post(`/Estabelecimento/CriaGrupoEstabelecimento`, params)
    .then(result => {
      if (result.data) {
        dispatch(listarGruposEstabelecimentos(e.projetoId))
      } else {
        console.error('erro', 'criarGrupoEstabelecimento');
        dispatch(modalClose())
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

      }
    })
    .catch(erro => {
        console.error(erro, 'criarGrupoEstabelecimento');
        dispatch(modalClose())
        dispatch(
          modalAlertaInfo({
            ...e.nlsPopup[7], // Inclui o conteúdo de nlsPopup[7]
            btnAction: ()=> dispatch(modalAlertaClean()),
            show: true, // Garante que o modal será exibido          
          })
        )

    });
  }
}

export const removerGrupoEstabelecimento = (e, nlsPopup) => {
  return dispatch => {
    api.delete(`/Estabelecimento/DeletaGrupoEstabelecimento?grupoEstabelecimentoID=${e.idGrupoEstabelecimento}`)
    .then(result => {
      if (result.data) {
        dispatch(listarGruposEstabelecimentos(e.idProjeto))
      } else {
        console.error('erro', 'removerGrupoEstabelecimento');
      }
    })
    .catch(({response: {data}}) => {
      dispatch(modalClose())
      if (data?.iderro === 111) {
        dispatch(modalAlertaInfo({
          ...nlsPopup['111'], 
          btnAction: ()=> dispatch(modalAlertaClean()),
          show: true,
        }))
      } 
    });
  }
}

export const listarSubsegmentos = e => {
  const params = paramsApi(e)
  return dispatch => {
    api.get(`/Produto/ListaSubSegmentosPorProjeto${params}`)
    .then(result => {
      dispatch(setFormProjetoLista({name: 'subsegmentos', value: result.data}))
    })
    .catch(err => {
        console.error(err, 'listarSubsegmentos');
    });
  }
}